import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateConfigService } from './translate-config.service';

declare const google: any; // Global Google Maps object loaded in index.html

export interface CitySuggestion {
  description: string;
  placeId: string;
  mainText: string;
  secondaryText: string;
  city?: string;
  country?: string;
}

@Injectable({ providedIn: 'root' })
export class GooglePlacesService {
  private autocompleteService: any | null = null;

  constructor(private translate: TranslateConfigService) {}

  private ensureService() {
    if (!this.autocompleteService && typeof google !== 'undefined' && google.maps?.places?.AutocompleteService) {
      this.autocompleteService = new google.maps.places.AutocompleteService();
    }
  }

  /**
   * Obtiene sugerencias de ciudades utilizando Google Places Autocomplete
   */
  getCitySuggestions(query: string): Observable<CitySuggestion[]> {
    return new Observable<CitySuggestion[]>((observer) => {
      if (!query || query.trim().length < 2) {
        observer.next([]);
        observer.complete();
        return;
      }

      this.ensureService();

      if (!this.autocompleteService) {
        observer.error('Google Places no disponible');
        return;
      }

  const language = (this.translate as any).getCurrentLanguage ? (this.translate as any).getCurrentLanguage() : 'es';

      const request: any = {
        input: query,
        types: ['(cities)'],
        language
      };

      this.autocompleteService.getPlacePredictions(request, (predictions: any[], status: string) => {
        if (status !== 'OK' || !predictions) {
          observer.next([]);
          observer.complete();
          return;
        }

        const mapped: CitySuggestion[] = predictions.map(p => ({
          description: p.description,
          placeId: p.place_id,
          mainText: p.structured_formatting?.main_text || p.description,
            secondaryText: p.structured_formatting?.secondary_text || '',
        }));

        observer.next(mapped);
        observer.complete();
      });
    });
  }
}
